"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePressOrSwitchChain = void 0;
var core_1 = require("@usedapp/core");
var react_1 = require("react");
var Web3Context_1 = require("../contexts/Web3Context");
var usePressOrSwitchChain = function usePressOrSwitchChain(props) {
  var _ref = (0, react_1.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    trigger = _ref2[0],
    setTrigger = _ref2[1];
  var _ref3 = (0, core_1.useEthers)(),
    chainId = _ref3.chainId;
  var _ref4 = (0, Web3Context_1.useSwitchNetwork)(),
    switchNetwork = _ref4.switchNetwork;
  var onPress = (0, react_1.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(props.chainId !== chainId && switchNetwork)) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return switchNetwork(props.chainId);
        case 3:
          // console.log("switched network?");
          setTrigger(true);
          _context.next = 7;
          break;
        case 6:
          props.onPress();
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [chainId, props, switchNetwork]);
  (0, react_1.useEffect)(function () {
    if (trigger && chainId === props.chainId) {
      props.onPress();
      setTrigger(false);
    }
  }, [trigger, chainId, props]);
  return onPress;
};
exports.usePressOrSwitchChain = usePressOrSwitchChain;